import http from './request'

// 获取活动信息
export const getBattleInfo = (data) => {
  return http({
    url: '/promotion/DragonTigerBattle/getInfo',
    method: 'post',
    data
  })
}

// PK对手
export const getOpponents = (data) => {
  return http({
    url: '/promotion/DragonTigerVirtualUser/getOpponents',
    method: 'post',
    data
  })
}

// 参与记录
export const getMyBattleRecords = (data) => {
  return http({
    url: '/promotion/DragonTigerBattleRecord/getUserRecords',
    method: 'post',
    data
  })
}

// 代理报名
export const battleSignUp = (data) => {
  return http({
    url: '/promotion/DragonTigerBattleUser/signUp',
    method: 'post',
    data
  })
}

// 选择对手
export const bindOpponent = (data) => {
  return http({
    url: '/promotion/DragonTigerBattleRecord/bindOpponent',
    method: 'post',
    data
  })
}

// 领取奖励
export const battleWinClaim = (data) => {
  return http({
    url: '/promotion/DragonTigerBattleRecord/claim',
    method: 'post',
    data
  })
}

// 上一期记录
export const getPastBattleRecords = (data) => {
  return http({
    url: '/promotion/DragonTigerBattleRecord/getRankPagedList',
    method: 'post',
    data
  })
}
